import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import HeaderLogo from "@/components/layout/HeaderLogo"; // Updated import
import { cn } from "@/lib/utils";
import { NavItem } from "@/types";
import { Button } from "@/components/ui/button";

const Navbar = () => {
  console.log("Navbar rendering");
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Create dynamic navigation items
  const mainNavItems: NavItem[] = [
    {
      title: "Hem",
      href: "/",
    },
    {
      title: "Community",
      href: "/community",
    },
    {
      title: "Om oss",
      href: "/om-oss",
    },
    {
      title: "Om demens",
      href: "/om-demens",
    },
    {
      title: "Berättelser",
      href: "/berattelser",
    },
    {
      title: "Kampanjer",
      href: "/kampanjer",
    },
    {
      title: "Kontakt",
      href: "/kontakt",
    },
  ];

  console.log("Navbar state:", { isOpen, scrolled, location: location.pathname });

  // Close mobile menu when navigating
  useEffect(() => {
    console.log("Location changed, closing mobile menu");
    setIsOpen(false);
  }, [location.pathname]);

  // Detect scroll for navbar background
  useEffect(() => {
    console.log("Setting up scroll listener");
    const handleScroll = () => {
      const newScrolled = window.scrollY > 10;
      if (newScrolled !== scrolled) {
        console.log("Scroll state changed:", newScrolled);
        setScrolled(newScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      console.log("Cleaning up scroll listener");
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const isActive = (path: string) => {
    const active = location.pathname === path;
    console.log(`Checking if ${path} is active:`, active);
    return active;
  };

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-3 bg-white/90 backdrop-blur-md shadow-sm"
      )}
    >
      <div className="container px-4 mx-auto">
        <div className="flex items-center relative">
          {/* Logo */}
          <div>
            <HeaderLogo /> {/* Updated usage */}
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8 mx-auto">
            {mainNavItems.map((item) => (
              <div key={item.href} className="relative group">
                <Link
                  to={item.href}
                  className={cn(
                    "text-sm font-medium transition-colors",
                    location.pathname === item.href // Use purple for active link
                      ? "text-minnestig-purple"
                      : "text-minnestig-teal hover:text-minnestig-purple" // Default to teal text
                  )}
                >
                  {item.title}
                </Link>
              </div>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden flex items-center ml-auto"
            onClick={() => {
              console.log("Mobile menu button clicked, current state:", isOpen);
              setIsOpen(!isOpen);
            }}
          >
            {isOpen ? (
              <X className="h-6 w-6 text-minnestig-teal" />
            ) : (
              <Menu className="h-6 w-6 text-minnestig-teal" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden shadow-lg animate-fadeIn bg-white">
          <div className="container px-4 py-6 flex flex-col space-y-4">
            {mainNavItems.map((item) => (
              <div key={item.href} className="flex flex-col">
                <Link
                  to={item.href}
                  className={cn(
                    "py-2 px-4 rounded-md transition-colors",
                    location.pathname === item.href // Active link style
                      ? "bg-minnestig-lavender text-minnestig-darkpurple" // Active style for white navbar
                      : "text-minnestig-teal hover:bg-minnestig-lavender/20" // Inactive style for white navbar
                  )}
                >
                  {item.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
